import './ImageList.css';
import React from 'react';
import ImageShow from './ImageShow'

const ImageList = ({image}) => {
  const ImageReander = image.map((images) =>{
    return <ImageShow key={images.id}images={images}/>
  } )

    return (
        <div className='img-list'>
        {ImageReander}  
        </div>
    );
}

export default ImageList;
